import { Action, combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { getStorage } from "../utils/storageConfig";
import ItemsManagementReducer from "./slices/ItemsManagementSlice";
import authReducer, { logout } from "./slices/authSlice";
import cartReducer from "./slices/cartSlice";
import commonReducer from "./slices/commonSlice";
import generalDrawerReducer from "./slices/generalDrawerSlice";
import generalToastReducer from "./slices/generalToastSlice";
import languageReducer from "./slices/languageSlice";
import notificationsReducer from "./slices/notificationsSlice";
import OfferReducer from "./slices/offerSlice";
import orderSessionStorageReducer from "./slices/orderSessionStorage";
import orderReducer from "./slices/orderSlice";
import profileReducer from "./slices/profileSlice";
import returnedOrderCartReducer from "./slices/returnedOrdersCart";
import searchReducer from "./slices/searchSlice";
import sharedCartReducer from "./slices/sharedCartSlice";
import generalReducer from "./slices/generalSlice";

// Combine reducers
const appReducer = combineReducers({
  auth: authReducer,
  order: orderReducer,
  cart: cartReducer,
  sharedCart: sharedCartReducer,
  returnedOrderCart: returnedOrderCartReducer,
  common: commonReducer,
  profile: profileReducer,
  ItemsManagement: ItemsManagementReducer,
  generalDrawer: generalDrawerReducer,
  offer: OfferReducer,
  generalToast: generalToastReducer,
  search: searchReducer,
  notifications: notificationsReducer,
  language: languageReducer,
  orderSessionStorage: orderSessionStorageReducer, // Add sessionStorage slice here
  general: generalReducer
});

// Create a dynamic persist config for each slice

// const createPersistedReducer = (key: string, reducer: any) => {
//   const persistConfig = {
//     key,
//     storage: getStorage(key),
//   };

//   return persistReducer(persistConfig, reducer);
// };

const persistConfig = {
  key: "root",
  storage: getStorage("root"),
  blacklist: ["general"],

};
// Root reducer with logic for logging out (clearing state)
const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: Action,
) => {
  if (action.type === logout.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

const isProductionEnv = window.appConfig.Environment === "PRODUCTION";

// Create a persisted reducer for the root app state
// const persistedReducer = createPersistedReducer("root", rootReducer);
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/FLUSH",
          "persist/REGISTER",
        ],
      },
    }),
  devTools: !isProductionEnv,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof appReducer>;
export type AppDispatch = typeof store.dispatch;
